import { CompanyT } from "@interfaces/company/company";
import { useCompaniesQuery, useSelectedCompanyQuery } from "@lib/company";
import { switchCompany } from "@store/company/company-store";
import { getCompanyLogo } from "@utils/getCompanyLogo";
import { useOnClickOutside } from "@hooks/useOnClickOutside";
import style from "@scss/components/header.module.scss";
import clsx from "clsx";
import { FC, ChangeEventHandler, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { BodyNormal } from "@ui/fonts";
import { TextField, List, ListItem } from "@mui/material";

export const CompanySearch: FC = () => {
  const history = useNavigate();
  const { company } = useSelectedCompanyQuery();
  const wrapperRef = useRef(null);
  const [open, setOpen] = useState<boolean>(false);
  const [search, setSearch] = useState<string>();

  const { companies } = useCompaniesQuery({
    searchString: search,
  });

  useOnClickOutside(wrapperRef, () => setOpen(false));

  const handleSelectCompany = (company: CompanyT) => {
    switchCompany({ id: company.id });
    setOpen(false);
    history("/company");
  };

  const handleSearchCompany: ChangeEventHandler<HTMLInputElement> = ({
    target,
  }) => {
    setSearch(target.value);
  };

  return (
    <div className={clsx(style.company_change)} ref={wrapperRef}>
      <div
        className={clsx(style.company_change_title)}
        onClick={() => setOpen(!open)}
      >
        {company?.image &&
        !company.image.includes("/img/static/dummy-logo.png") ? (
          <img
            src={getCompanyLogo(company.image)}
            alt=""
            className={style.headerLogoImg}
          />
        ) : (
          <BodyNormal sx={{ fontSize: 14 }} weight="bold">
            {company?.name}
          </BodyNormal>
        )}
      </div>
      <div
        className={clsx(style.company_change_search, {
          [style.company_change_search_open]: open,
        })}
      >
        <TextField
          variant="outlined"
          size="small"
          fullWidth
          onChange={handleSearchCompany}
          value={search}
          placeholder="Начните вводить название"
        />
        <List>
          {companies &&
            companies.map((item) => (
              <ListItem onClick={() => handleSelectCompany(item)}>
                {item.name}
              </ListItem>
            ))}
        </List>
      </div>
    </div>
  );
};
